import { FIM_ENTRY_ASSET_INSTANCE, FIM_ENTRY_SUBJECT } from './types'

/**
 * Canonical inverse of `subjectEntryId`: recover a Subject UID from its entry
 * id. Subject data does not carry its own uid, so every consumer joins through
 * this helper rather than hand-stripping the prefix.
 */
export const subjectUidFromEntryId = (entryId: string): string =>
  entryId.startsWith(`${FIM_ENTRY_SUBJECT}-`)
    ? entryId.slice(`${FIM_ENTRY_SUBJECT}-`.length)
    : entryId

/** Canonical inverse of `assetInstanceEntryId`. */
export const assetInstanceUidFromEntryId = (entryId: string): string =>
  entryId.startsWith(`${FIM_ENTRY_ASSET_INSTANCE}-`)
    ? entryId.slice(`${FIM_ENTRY_ASSET_INSTANCE}-`.length)
    : entryId
